import { useRef, useState } from "react";
import { MediaInput } from "@zendeskgarden/react-forms";
import { SearchIcon } from "@/assets/Icons";
import type { InputSearchProps, InputSearchOption } from "./interface";
import { InputSearchContainer, DropdownList, DropdownItem, DropdownMessage, ExpandedList } from "./style";

export function InputSearch({ label, placeholder, options, onSelect, disabled, isLoading, expanded }: InputSearchProps) {
  const [query, setQuery] = useState("");
  const [open, setOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  const filtered = query.trim()
    ? options.filter((o) => o.label.toLowerCase().includes(query.toLowerCase()))
    : [];

  function handleSelect(option: InputSearchOption) {
    onSelect(option);
    setQuery("");
    if (!expanded) setOpen(false);
  }

  const showDropdown = open && !disabled;

  if (expanded) {
    return (
      <InputSearchContainer ref={containerRef} style={{ flex: 1, minHeight: 0 }}>
        {label && <InputSearchContainer.Label>{label}</InputSearchContainer.Label>}
        <MediaInput
          start={<span style={{ display: "flex", alignItems: "center", paddingRight: "8px" }}><SearchIcon /></span>}
          placeholder={placeholder}
          value={query}
          disabled={disabled}
          onChange={(e) => setQuery(e.target.value)}
        />
        {query.trim() && (
          <ExpandedList>
            {isLoading && <DropdownMessage>Carregando...</DropdownMessage>}
            {!isLoading && filtered.length === 0 && (
              <DropdownMessage>Nenhum resultado encontrado</DropdownMessage>
            )}
            {!isLoading && filtered.map((option) => (
              <DropdownItem key={option.id} onClick={() => handleSelect(option)}>
                {option.label}
              </DropdownItem>
            ))}
          </ExpandedList>
        )}
      </InputSearchContainer>
    );
  }

  return (
    <InputSearchContainer ref={containerRef}>
      {label && <InputSearchContainer.Label>{label}</InputSearchContainer.Label>}
      <div style={{ position: "relative" }}>
        <MediaInput
          start={<span style={{ display: "flex", alignItems: "center", paddingRight: "8px" }}><SearchIcon /></span>}
          placeholder={placeholder}
          value={query}
          disabled={disabled}
          onChange={(e) => {
            setQuery(e.target.value);
            setOpen(true);
          }}
          onFocus={() => setOpen(true)}
          onBlur={() => setTimeout(() => setOpen(false), 150)}
        />
        {showDropdown && (
          <DropdownList>
            {isLoading && <DropdownMessage>Carregando...</DropdownMessage>}
            {!isLoading && filtered.length === 0 && (
              <DropdownMessage>Nenhum resultado encontrado</DropdownMessage>
            )}
            {!isLoading && filtered.map((option) => (
              <DropdownItem key={option.id} onMouseDown={() => handleSelect(option)}>
                {option.label}
              </DropdownItem>
            ))}
          </DropdownList>
        )}
      </div>
    </InputSearchContainer>
  );
}
